import { STORAGE_ITEMS, STORAGE_KEYS } from "../constants";

export const StorageService = {
  setInStorage(key, value, storage = STORAGE_KEYS.SESSION_STORAGE) {
    if (storage === STORAGE_KEYS.SESSION_STORAGE) {
      this.setInSessionStorage(key, value);
    }
    if (storage === STORAGE_KEYS.LOCAL_STORAGE) {
      this.setInLocalStorage(key, value);
    }
  },
  getFromStorage(key, storage = STORAGE_KEYS.SESSION_STORAGE) {
    if (storage === STORAGE_KEYS.SESSION_STORAGE) {
      return this.getFromSessionStorage(key);
    }
    if (storage === STORAGE_KEYS.LOCAL_STORAGE) {
      return this.getFromLocalStorage(key);
    }
  },
  removeFromStorage(key, storage = STORAGE_KEYS.SESSION_STORAGE) {
    if (storage === STORAGE_KEYS.SESSION_STORAGE) {
      sessionStorage.removeItem(key);
    }
    if (storage === STORAGE_KEYS.LOCAL_STORAGE) {
      localStorage.removeItem(key);
    }
  },

  setInSessionStorage(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value));
  },
  setInLocalStorage(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  },

  getFromSessionStorage(key) {
    if (
      process.browser &&
      window &&
      typeof window.sessionStorage !== undefined
    ) {
      const item = sessionStorage.getItem(key);
      if (item) return JSON.parse(item);
    }
    return "";
  },
  getFromLocalStorage(key) {
    const item = localStorage.getItem(key);
    if (key === "recSessionId") return JSON.parse(JSON.stringify(item));
    if (item) return JSON.parse(item);
    return "";
  },

  getSessionId() {
    return this.getFromLocalStorage(STORAGE_ITEMS.recruiterSessionId);
  },
  setContactDetailsJobId(jobId) {
    this.setInStorage("contactDetailsJobId", jobId);
  },

  getContactDetailsJobId() {
    return this.getFromStorage("contactDetailsJobId");
  },

  removeContactDetailsJobId() {
    this.removeFromStorage("contactDetailsJobId");
  },
  removeFromLocalStorage(key) {
    localStorage.removeItem(key);
  },
  modifyObjectForStorage({ obj, timeOutInMinutes }) {
    const updatedObj = {
      ...obj,
      lastUpdated: Date.now(),
      timeOutInMs: timeOutInMinutes * 60 * 1000
    };

    return updatedObj;
  },
  checkObjectForTimeOut({ obj }) {
    const now = Date.now();
    if (obj.lastUpdated && obj.timeOutInMs) {
      if (now - obj.lastUpdated > obj.timeOutInMs) {
        return true;
      }
      return false;
    }
    return true;
  }
};
